import BusinessLogo from "../../assets/images/logos/grainshark/grainshark.png";


const styles = {
	mainColor: "#1B3666",
	backgroundColor: "#F2F2F2",
	primaryColor: "#065fd3",
	primaryVariant: "#F2F2F2",
	secondaryColor: "#065fd3",
	secondaryVariant: "#065fd3",
	surface: "#FFF",
	transparentMainColor: "rgba(21,111,152,0.9)",
	homeFontColor: "#FFF",
	logo: BusinessLogo,
	isLogoSquared: true,
};

export default styles;
